import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { plainToClassFromExist } from 'class-transformer';
import { Subscriber } from 'rxjs';
import { MarcheAPIService } from '../@core/api/marche-api.service';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { SnackBarService } from '../@core/snackbar.service';
import {
    ErrorWrapper,
    ResponseWrapper,
} from '../@shared/models/response-wrapper.model';
import { Content, TOPDATA } from './tranding-offer.data';
import { SeoService } from '../@core/seo.service';
import { MediaCDNService } from '../@core/media-cdn.service';

@Component({
    selector: 'app-tranding-offer',
    templateUrl: './tranding-offer.component.html',
    styleUrls: ['./tranding-offer.component.scss'],
})
export class TrandingOfferComponent extends RouteExecutor implements OnInit {
    static readonly TOS_DATA_API = '/trendingOffers';
    static readonly TOS_SEO_API = '/trendingOffers/seo';

    footerContent = '';

    private layoutBasedFlex: Record<string, string> = {
        center: '0 0 40%',
        'center-center': '0 0 100%',
        'center-start': '0 0 40%',
        'image-right': '0 0 47%',
        'image-left': '0 0 47%',
        'video-right': '0 0 47%',
        'video-left': '0 0 47%',
        default: '0 0 40%',
    };
    private layoutBasedOrder: Record<string, string> = {
        'center-end': '1',
        'end-center': '1',
        'center-start': '0',
        'end-start': '1',
        'image-right': '1',
        'video-right': '1',
        default: '0',
    };

    data: TOPDATA | undefined;
    errors: ErrorWrapper[] | undefined = [];
    loading = false;
    showShimmer = true;
    panelOpenState = false;
    wishlistArray: Array<number> = [];
    fireChanges = false;
    errorCaught = false;
    posterImageCDN = '';
    webm = '';
    activeTab = 0;

    getFlex(item: Content): string {
        return (
            this.layoutBasedFlex[item.alignment] || this.layoutBasedFlex.default
        );
    }

    getFlexOrder(item: Content) {
        return (
            this.layoutBasedOrder[item?.alignment] ||
            this.layoutBasedOrder.default
        );
    }

    @Input() filter: { [p: string]: string | string[] } = {};

    constructor(
        applicationRouterService: ApplicationRouterService,
        private activatedRoute: ActivatedRoute,
        private snackbarService: SnackBarService,
        private marcheAPIService: MarcheAPIService,
        private seoService: SeoService,
        private route: Router,
        public mediaCDN: MediaCDNService
    ) {
        super(applicationRouterService);
        this.activatedRoute.queryParams.subscribe(param => {
            this.loading = true;
            this.filter = param;
            this.trandingOfferData();
        });

        this.processLink(`/fn/internal?page=trendingOffers&action=nav-update`);
        this.updateSeo();
    }

    ngOnInit(): void {}

    trandingOfferData() {
        const subscriber = Subscriber.create<ResponseWrapper<TOPDATA> | null>(
            value => {
                if (value?.success) {
                    this.data = value.data;
                    this.webm = ',f-webm';
                    this.posterImageCDN = this.mediaCDN.getImageCDN();
                    console.log(this.data, 'tranding');
                } else {
                    this.errorCaught = true;
                    this.errors = value?.errors;
                    plainToClassFromExist(this.errors, value?.errors);
                }
                this.loading = false;
            },
            error => {},
            () => {
                this.showShimmer = false;
            }
        );
        this.marcheAPIService
            .getRequest<ResponseWrapper<TOPDATA> | null>(
                TrandingOfferComponent.TOS_DATA_API,
                this.filter
            )
            .subscribe(subscriber);
    }

    convertWebToMp4(link: string): string {
        const links = link.split('.');
        links[links.length - 1] = 'mp4';
        let newLink = '';
        newLink = links.join('.');
        newLink = newLink + '?tr=q-50';
        return newLink;
    }

    updateSeo() {
        this.marcheAPIService
            .getRequest<ResponseWrapper<any>>(
                TrandingOfferComponent.TOS_SEO_API,
                this.filter
            )
            .subscribe(res => {
                if (res?.success) {
                    this.footerContent = res?.data?.footerContent;
                    this.seoService.updateMetaTitle(res?.data?.meta?.title);
                    this.seoService.updateMetaDescription(
                        res?.data?.meta?.description
                    );
                    this.seoService.updateCanonical(res?.data?.canonical);
                } else {
                    this.seoService.updateMetaTitle('DailyObjects');
                    this.seoService.updateMetaDescription('');
                    this.seoService.updateCanonical(this.route.url);
                }
            });
    }
}
